const isTiptapErrorEvent = (event: PromiseRejectionEvent) => {
  const errorMessage =
    event.reason?.message ||
    (typeof event.reason === 'string' ? event.reason : '')

  return (
    errorMessage.includes('Cannot read properties of null') &&
    event.reason?.stack?.includes('getBoundingClientRect')
  )
}

const isSlateErrorEvent = (event: ErrorEvent) =>
  event.message?.includes('Cannot get the leaf node at path [0,0]')

window.addEventListener(
  'unhandledrejection',
  (event: PromiseRejectionEvent) => {
    const shouldBeSuppressed = isTiptapErrorEvent(event)

    if (shouldBeSuppressed) {
      event.preventDefault()
      event.stopPropagation()
    }
  },
)

window.addEventListener('error', (event: ErrorEvent) => {
  const shouldBeSuppressed = isSlateErrorEvent(event)

  if (shouldBeSuppressed) {
    event.preventDefault()
    event.stopPropagation()
  }
})
